<template>
    <section class="form">
        <form @submit.prevent="addNewReview" class="form-beer">
            <h3>Add Review for {{ beer.beerName }}</h3>
            <div>
                <p>Username: {{ userName }}</p>
                <label for="rating">Rating: </label>
                <select name="rating" id="cars" v-model="rating" placeholder="5">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            <div>
                <label class="sr-only">Review:</label>
                <textarea v-model="reviewText" placeholder="Type your review here" type="textarea"></textarea>
            </div>
            <div>
                <button type="submit" class="button">Submit</button>
                <button v-on:click.prevent="resetForm" class="button">Cancel</button>
            </div>
        </form>
    </section>
</template>
  
<script>
export default {
    name: "review-form",
    methods: {
        addNewReview() {
            this.$store.commit("ADD_REVIEW", {reviewId:this.nextId,beerID:this.beerId,brewery_id:this.beer.brewery_id,username:this.userName,rating:this.rating,reviewText:this.reviewText});
            this.$router.push(`/beer/${this.paramsId}`)
        },
        resetForm() {
            this.rating = 0;
            this.reviewText = "";
        }
    },
    data() {
        return {
            message: "",
            paramsId: parseInt(this.$route.params.id),
            reviewId: 5,
            beerId: parseInt(this.$route.params.id),
            brewery_id: 5,
            userName: this.$store.state.username,
            rating: 0,
            reviewText: ""
        }
    },
    computed: {
        beer() {
        return this.$store.getters.getBeerByID(this.paramsId)
      },
      nextId() {
        let reviews = this.$store.state.reviews;
        let last = reviews[reviews.length-1].reviewId;
        return parseInt(last + 1)
      }
    }
}
</script>